import React, { Component } from 'react';

class GridBackorderedCellTemplate extends Component {
    constructor(props){
        super();
        
        this.props = props;
    }

    render(){ 
        return (
            <td>
                <div className="type--center">
                    {this.props.dataItem[this.props.field] ?        
                        <i className= {"u-icon u-icon--med-lrg u-icon--backordered"}></i> :          
                        (this.props.displayFaultyValue ?  <i className="u-icon u-icon--sml u-icon--inactive"></i>  : null)
                    }
                </div>
            </td>
        );
    }
}

export default GridBackorderedCellTemplate;